import React from 'react'
import Loader from '../../../components/Loader'
import styled from 'styled-components'
import Colors from '../../../assets/styles/Colors'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import Responsive from '../../../assets/config/Responsive'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import CompanySelect from '../../../components/v2/CompanySelect'
import { useTranslation } from 'react-i18next'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import { useNavigate } from 'react-router-dom'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import { useAppDispatch, useAppSelector } from '../../../store'
import { CriticalIllnessState, setChooseMethod, setCompanyId } from '../../../store/criticalIllnessSlice'
import CriticalProgressbar from '../../../components/v2/progrees-bars/CriticalProgressbar'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import api from '../../../api'
import { AppState } from '../../../store/appSlice'

const CriticalChooseMethod = () => {
  //
  const { t } = useTranslation()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const navigate = useNavigate()
  //
  const dispatch = useAppDispatch()
  //
  const { filter, screenHeader } = useAppSelector((data: { critical: CriticalIllnessState }) => data.critical)
  //
  const { data: pageInfo, isLoading: isPageInfoLoading } = api.useGetPetPageInfoQuery('critical-trust-us-or-yourself')
  //
  const pageTitle = pageInfo?.translations?.[lang]?.title
  const stepName = pageInfo?.translations?.[lang]?.stepName
  const listItems = pageInfo?.listItems?.slice().sort((a, b) => a.sort - b.sort)
  //
  const leftCompanies = {
    companiesCount: 2,
  }
  //
  const CriticalCompanies = filter.companyOffers
  //
  const SelectedCompanyArr: CriticalIllnessState['filter']['selectedCompanies'] = filter.selectedCompanies
  //
  const matchingObjects = CriticalCompanies?.filter((obj) => SelectedCompanyArr?.includes(obj.companyId as never))
  //
  const mainLoading = isPageInfoLoading
  //
  return mainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={pageTitle} />

        <CriticalProgressbar stepName={stepName} />

        <Block>
          {listItems?.map((item, index) => {
            return (
              <HorizontalCard
                className="horizontal-card"
                key={index}
                disabled={false}
                title={item?.translations?.[lang]?.title}
                description={item?.translations?.[lang]?.body}
                imgUrl={item?.image}
                selected={item.type === filter.chooseMethod ? true : false}
                onClick={() => [dispatch(setChooseMethod(item.type))]}
              >
                {/*change filter choosemethod*/}
                {item.type === filter.chooseMethod && filter.chooseMethod === 'my-choice' ? (
                  <Inner>
                    <hr />
                    <CompanyTitle>{t('chooseInsuranceCompany')}</CompanyTitle>
                    <CompanyDescription>{t('chooseInsuranceCompanyRules')}</CompanyDescription>

                    <CompanySelect
                      closeMenuOnSelect={false}
                      onChange={(data) => dispatch(setCompanyId(data.map((item: any) => item.value)))}
                      isMulti={true}
                      maxSelectText={`${t('companyCmpare')}`}
                      placeholder={t('selectCompanies')}
                      showOptionCheckbox={true}
                      value={matchingObjects?.map((s) => ({
                        label: s.brandName?.[lang]?.title,
                        value: s.companyId,
                        imgUrl: s.companyLogo,
                      }))}
                      options={
                        CriticalCompanies?.map((item) => ({
                          value: item.companyId,
                          label: item.brandName?.[lang]?.title,
                          imgUrl: item.companyLogo,
                        })) || []
                      }
                    />
                  </Inner>
                ) : null}
              </HorizontalCard>
            )
          })}
          <RemainingCompanies
            style={{
              opacity: leftCompanies ? '1' : '0',
              marginTop: '-10px',
            }}
            text={`${t('offerAvailable')}: ${leftCompanies?.companiesCount} `}
          />{' '}
        </Block>

        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => [navigate('/critical-add-insured')]}
          />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={
              filter.chooseMethod && (filter.chooseMethod === 'frani-choice' || filter.chooseMethod === 'my-choice')
                ? false
                : true
            }
            onClick={() => {
              if (filter.chooseMethod === 'frani-choice') {
                navigate('/critical-offer')
              }
              //
              if (filter.chooseMethod === 'my-choice') {
                navigate('/critical-offers')
              }
            }}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
const CompanyTitle = styled.p`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 1px;
`
const CompanyDescription = styled.p`
  font-size: 14px;
  color: ${Colors.nevadaGrey};
  margin-bottom: 18px;
`
const Inner = styled.div`
  /*  */
`
const Block = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  margin-inline: auto;
  max-width: 464px;
  width: 100%;

  gap: 24px;
  ${Responsive.mobile} {
    margin-top: 24px;
    gap: 20px;
  }
`

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 48px;
  width: min-content;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    gap: 16px;
    button {
      width: 140px;
    }
  }
`
const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  position: relative;
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
`

export default CriticalChooseMethod
